module.exports = __webpack_public_path__ + "static/finance-guide-645c3890986fc00d10c3cdf0424936e0.png";